import Template from "./template";
import invariant from "invariant";

export default class GenericTemplate extends Template {
	static listUrl({ organizationId }) {
		invariant(organizationId != null, "[Model][Template] organizationId is mandatory");
		return `/target/organizations/${organizationId}/generic-templates`;
	}
}
